import tracking from '@finn-no/analytics';

export function trackEvent(analyticsName, eventFlags, kpi) {
    tracking.trackEvent({
        analyticsName,
        kpi,
        eventFlags,
    });
}

export function trackEventObject(eventObj) {
    tracking.trackEvent(eventObj);
}

export default {
    name: 'trackingservice',
    eager: true,
    callable() {
        init();

        function init() {
            setupContextData();
            _handleTrels();
            setTimeout(trackCurrentPage, 0); // Delays tracking until all other controllers are executed.
        }

        function _handleTrels() {
            const url = new URL(document.baseURI);
            const trels = url.searchParams.getAll('trel');
            if (trels.length) {
                url.searchParams.delete('trel');
                history.replaceState(null, null, url.href);
                trels.forEach(deprecatedTrackEvent);
            }
        }

        function setupContextData() {
            tracking.setPageContext({
                site: 'www.finn.no',
                'client.application': 'm.finn',
            });
        }

        function setContextParam(key, value) {
            tracking.setPageContext(key, value);
        }

        let currentPageContext = null;

        function setContextForCurrentPageTracking(contextObj) {
            currentPageContext = contextObj;
        }

        function trackCurrentPage(eventObj) {
            const sanitizedEventObj = eventObj || {};
            if (currentPageContext) {
                sanitizedEventObj.context = Object.assign(
                    {},
                    sanitizedEventObj.context,
                    currentPageContext
                );
            }
            tracking.trackPage(sanitizedEventObj);
            customPageTracking();
        }

        function customPageTracking() {
            let path = window.location.pathname;

            if (path[0] !== '/') {
                // normalize IE path
                path = `/${path}`;
            }

            // this can be removed after week 5 2018. (frorisoy)
            const match = path.match(/car\/(\w+)?\/?(browse|ad|search).html?/i);
            if (match) {
                const key = match[2];
                new Image().src = `https://cookie.norstatsurveys.com/api/trackingpixel/39e2704010582c1cc9e06d6783bf30a3/${key}`;
            }
        }

        function deprecatedTrackEvent(eventName) {
            tracking.trackEvent({ eventName });
        }

        function trackLater(analyticsName, eventFlags, kpi) {
            trackLaterObj({
                analyticsName,
                kpi,
                eventFlags,
            });
        }

        function trackLaterObj(eventObj) {
            tracking.trackEventLater(eventObj);
        }

        function getApi(callback) {
            tracking.getApi(callback);
        }

        return {
            deprecatedTrackEvent,
            trackCurrentPage,
            trackEvent,
            trackEventObject,
            trackLater,
            trackLaterObj,
            setContextParam,
            setContextForCurrentPageTracking,
            getApi,
        };
    },
};



// WEBPACK FOOTER //
// ./services/trackingService.js